export const NULL_ADDRESS = '0x0000000000000000000000000000000000000000';

/**
 * TODO: VOV: To be removed
 *
 * @deprecated
 */
export const HARDCODED_TRADING_PAIR_ADDRESS = '0xd3cea115Fbb976e4606348180022065198FDE6F4';
